import { action } from "../action-creator";
import { VIRTUAL_TRYON } from "./virtual-tryon.reducer";
import {
    IVirtualTryOnCreatePayload,
    IVirtualTryOnUpdatePayload,
    IVirtualTryOn,
} from "../../models/virtualtryon.model";

export const types = {
    GET: "get",
    CREATE: "create",
    UPDATE: "update",
    DELETE: "delete",
    SET: "set",
    CLEAR: "clear",
    RESTORE_INITIAL: "restore initial",
};

export const getVirtualTryOnAction = (stylizationId: number, guid: string) =>
    action(VIRTUAL_TRYON, types.GET, { stylizationId, guid });
export const createVirtualTryOnAction = (payload: IVirtualTryOnCreatePayload) =>
    action(VIRTUAL_TRYON, types.CREATE, payload);
export const updateVirtualTryOnAction = (payload: IVirtualTryOnUpdatePayload) =>
    action(VIRTUAL_TRYON, types.UPDATE, payload);
export const deleteVirtualTryOnAction = (stylizationId: number) =>
    action(VIRTUAL_TRYON, types.DELETE, stylizationId);
export const setVirtualTryOnAction = (payload: IVirtualTryOn) =>
    action(VIRTUAL_TRYON, types.SET, payload);
export const clearVirtualTryOnAction = () => action(VIRTUAL_TRYON, types.CLEAR);
export const restoreVirtualTryOnInitialStateAction = () =>
    action(VIRTUAL_TRYON, types.RESTORE_INITIAL);
